import { ReactNode } from "react";
import { createGlobalStyle, ThemeProvider } from "styled-components";

const GlobalStyles = createGlobalStyle`
  html,body {
    overflow-x: hidden;
  }
  p {
    margin: 0;
    padding: 0;
  }
  h1 {
    margin: 0;
    padding: 0;
  }
`;

const theme = {
  colors: {
    primary: "#0078E7",
    secondary: "#6A37FC",
    textColor: "#030068",
  },

  breakpoints: {
    sm: "576px",
    md: "768px",
    lg: "992px",
    xl: "1200px",
    xxl: "1600px",
  },

  up: (breakpoint: string, vertical: boolean = false) =>
    `@media (min-${
      vertical ? "height" : "width"
    }: calc(${breakpoint} + 0.02px))`,
  down: (breakpoint: string, vertical: boolean = false) =>
    `@media (max-${vertical ? "height" : "width"}: ${breakpoint})`,
  between: (
    breakpointMin: string,
    breakpointMax: string,
    vertical: boolean = false
  ) =>
    `@media (max-${vertical ? "height" : "width"}: ${breakpointMax}) and (min-${
      vertical ? "height" : "width"
    }: calc(${breakpointMin} + 0.02px))`,
};

type IProps = {
  children: ReactNode;
};

const BaseLayout = ({ children }: IProps) => (
  <>
    <GlobalStyles />
    <ThemeProvider theme={theme}>{children}</ThemeProvider>
  </>
);

export default BaseLayout;
